import Layout from "../../components/Layout/Layout.react";
import JobDetail from "../../components/GlobalJobBoard/JobDetail";
import { getJob, HireXLJobBoardError, listJobs } from "../../lib/server/hirexlGlobalJobBoardClient";
import { jobUrl } from "../../lib/job-board/url";

export default function JobPage({ job, relatedJobs, unavailable, boardUnavailable }) {
  if (boardUnavailable) {
    return <Layout title="Job board unavailable | HireXL" description="The Global Job Board is currently unavailable."><main className="container wrapper-padding"><h1>The Global Job Board is currently unavailable.</h1></main></Layout>;
  }
  if (unavailable || !job) {
    return (
      <Layout title="Job unavailable | HireXL" description="This job is no longer available.">
        <main className="container wrapper-padding"><h1>This job is no longer available.</h1><p>Please browse the current job listings.</p></main>
      </Layout>
    );
  }
  return (
    <Layout title={`${job.title} | HireXL`} description={`Apply for ${job.title}.`}>
      <JobDetail job={job} relatedJobs={relatedJobs} captchaSiteKey={process.env.NEXT_PUBLIC_HIREXL_CAPTCHA_SITE_KEY || undefined} />
    </Layout>
  );
}

export async function getServerSideProps({ query }) {
  const value = Array.isArray(query.slug) ? query.slug[0] : query.slug;
  const slug = typeof value === "string" ? value.toLowerCase().slice(0, 200) : "";
  const match = slug.match(/^(.+)-(\d+)$/);
  if (!match) return { props: { unavailable: true } };

  try {
    const job = await getJob(match[2]);
    const canonicalUrl = jobUrl(job.title, job.id);
    if (canonicalUrl !== `/job/${slug}`) {
      return { redirect: { destination: canonicalUrl, permanent: true } };
    }

    const relatedJobs = await listJobs({ page: 1, limit: 4 })
      .then((result) => result.hits.filter((item) => item.id !== job.id).slice(0, 3))
      .catch(() => []);
    return { props: { job, relatedJobs } };
  } catch (error) {
    if (error instanceof HireXLJobBoardError && error.status === 404) return { props: { unavailable: true } };
    return { props: { boardUnavailable: true } };
  }
}
